// extracted by mini-css-extract-plugin
module.exports = {"root":"IconButton-module__root--Mpsbb","sizeSmall":"IconButton-module__sizeSmall--1ThYg"};